import React from "react";

/**
 * Kadra Talent two-line serif wordmark.
 *  - "dark"  → header (light bg): deep teal-green text.
 *  - "light" → footer (dark bg): white text.
 */
export default function Logo({ variant = "dark", className = "", height = 72 }) {
  const isLight = variant === "light";
  return (
    <span
      data-testid="kt-logo"
      aria-label="Kadra Talent"
      className={className}
      style={{
        height,
        display: "inline-flex",
        flexDirection: "column",
        justifyContent: "center",
        lineHeight: 0.95,
        fontFamily: "var(--font-display)",
        color: isLight ? "var(--white)" : "var(--green-800)",
        letterSpacing: "-0.005em",
        fontSize: Math.round(height * 0.46),
      }}
    >
      <span>Kadra</span>
      <span>Talent</span>
    </span>
  );
}
